import { useTranslation } from 'react-i18next';
import ErrorPage from '@casops/templates/error-page/ErrorPage';

export function NoAccess() {
  const { t } = useTranslation();

  return <ErrorPage title={t('NotAuthorized')} message={t('NoAccess')} />;
}

export default NoAccess;
